module.exports = __webpack_public_path__ + "img/S220.c61b83f1.jpg";